exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".continue-message-box {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.continue-message-box .continue-message-box__invisible {\n  visibility: hidden;\n  margin-bottom: auto;\n}\n\n.continue-message-box .continue-message-box__buttons {\n  margin-bottom: auto;\n}\n\n.continue-message-box .continue-message-box__buttons>button {\n  margin-bottom: 3vh;\n}\n\n.continue-message-box h1 {\n  margin-bottom: 5vh;\n}\n\n.continue-message-box h2 {\n  white-space: pre-wrap;\n}\n\n", ""]);

// exports
